import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import styles from "styles/modules/moduleHeader.module.scss";
import HomeIcon from "img/HomeIC.svg";
import CloudIcon from "img/cloudIcon.svg";
import HelpIcon from "img/helpIcon.svg";
import PlayIcon from "img/playIcon.svg";
import { ModuleContext } from "contexts/ModuleContext";
import { routes, getMlrStatusIcon } from "Uitls/Util";
import { BoldText } from "components/Texts";
import { ToolTipText } from "components/TooltipText";
import OverlayPopOver from "Uitls/OverlayPopOver";

function ModuleHeader(props) {
  const { moduleHeaderData, labelData, isBussinessRulesView = false } = props;
  const { module } = useContext(ModuleContext);
  const history = useHistory();

  return (
    <div className="row align-items-center pt-1 pb-1">
      <div className="col-md-6">
        <div className={`d-flex align-items-center homeHeaderSection`}>
          <div
            className={`d-flex align-items-center pt-1 plr15 pb-1 ${styles.homeHeaderSection}`}
          >
            <div>
              <img
                src={HomeIcon}
                alt="Home"
                onClick={() => {
                  const selectTab = isBussinessRulesView ? 1 : 0;
                  history.push({
                    pathname: routes.dashboard,
                    state: {
                      selectedTab: selectTab,
                    },
                  });
                }}
                className="cursor-pointer"
              />
            </div>
            <div className={styles.homeIconDivider}>
              {/* <span className={`d-block ${styles.minHeight8}`} /> */}

              <span className="d-block">
                {labelData?.pageTitle ? labelData.pageTitle : "Create Module"}
              </span>
              <OverlayPopOver
                element={
                  <BoldText
                    className={`d-block bold600 ${styles.minHeight16} ellipssesSingleLine`}
                  >
                    {module?.moduleName}
                  </BoldText>
                }
                overlayData={
                  <ToolTipText className="scollable-tooltip customScrollBar">
                    {module?.moduleName || "-"}
                  </ToolTipText>
                }
                trigger={["hover", "focus"]}
                placement="bottom"
                classId="tooltip"
              />

              {/* <span className={`d-block ${styles.minHeight16}`} /> */}
            </div>
          </div>
          {/* <div
            className={`ml-3  ${styles.secondryLinksDivider} ${styles.secondryLinks}`}
          >
            <img src={CloudIcon} alt="Save Changes" />
            Save changes
          </div> */}
          <div
            className={`ml-3 ${styles.secondryLinks}`}
            onClick={() => {
              window.open(
                "https://gileadconnect.sharepoint.com/sites/GPART-DAM_ModularContent/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FGPART%2DDAM%5FModularContent%2FShared%20Documents%2FQuick%20Reference%20Guides%20%28QRGs%29&viewid=4c6420d9%2Dce10%2D4215%2Dba49%2D666b6cd6b53f&newTargetListUrl=%2Fsites%2FGPART%2DDAM%5FModularContent%2FShared%20Documents&viewpath=%2Fsites%2FGPART%2DDAM%5FModularContent%2FShared%20Documents%2FForms%2FAllItems%2Easpx&xsdata=MDV8MDJ8fDY4ODBjNTc4NWU2NjQxOTI3NDA4MDhkZTA2NjA4NzYwfDZkNzg3YWI3ZjI5NTQyNGZiOGNjZTMxMTZhMGY4NTIwfDB8MHw2Mzg5NTUyMDg3OTEwNjE1MTJ8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T20xbFpYUnBibWRmVFcxU2FGbDZhR3hOYW1kMFdWUnJNazU1TURCTmVtczBURmRLYTFwcVRYUk9SRnBwVG1wcmQxcEhUWGRPVjA1cVFIUm9jbVZoWkM1Mk1pOXRaWE56WVdkbGN5OHhOelU1T1RJME1EYzRNREU0fDc3MDA1YTcyMjQyZDQ2YTRlNDk5MDhkZTA2NjA4NzVmfDVjNmU0YjU5NDgyMzQxZTM4NjhjZDRlNmVjYzlhNTAy&sdata=V083bnFubThUOVpZcEpNMU5uWnVSOFZUOVpja04rdkQvdU5TSkdKdEg4cz0%3D&ovuser=6d787ab7-f295-424f-b8cc-e3116a0f8520%2Cmanaswin.pandey%40indegene.com",
                "_blank"
              );
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <img src={HelpIcon} alt="Help" />
            Help
          </div>
          {/* <div className={`${styles.secondryLinks}`}>
            <img src={PlayIcon} alt="Tutorials" />
            Tutorial
          </div> */}
        </div>
      </div>
      <div className="col-md-6 text-right"></div>
    </div>
  );
}

export default ModuleHeader;
